export default function OvalsModule(element) {
    let attachTo = element.getAttribute('data-attach-to');
    let style = element.getAttribute('data-style');

    let $anchor = document.querySelector(attachTo);

    $anchor.parentNode.insertBefore(element, $anchor.nextSibling);

    if (style) {
        element.style = style;
    }
}
